<template>
  <v-row>
    <v-col>
      <v-sheet 
          width="100%"
          outlined
      >
        <v-row>
          <v-col 
            cols="12" 
            xl="6" 
            md="6" 
            sm="12" 
            class="pa-8">
            <v-btn 
              @click="addComunicactionChannel"
              color="primary">
              Nueva posición
            </v-btn>
          </v-col>

          <v-col 
            cols="12" 
            xl="6" 
            md="6" 
            sm="12" 
            class="pa-8">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
            
          <v-col cols="12">

            <v-data-table
              :headers="headers"
              :items="positions"
              :search="search"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50],
                'items-per-page-text':'Filas por página'
              }"
              :items-per-page="30"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="warning"
                  @click="editPosition(item.id)"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>

                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="red"
                  @click="confirmDelete(item.id)"
                >
                  <v-icon dark small>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
    
    <v-dialog
      v-model="dialog_new"
      width="700">
      <v-card>
        <v-card-title class="text-h6">
          Nuevo
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="name"
                outlined
                label="Nombre de la posición">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="short_name"
                outlined
                label="Nombre corto">
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                outlined
                :maxlength="375"
                :counter="375"
                :rules="[v => (v || '' ).length <= 374 || 'La descripción no debe tener mas de 375 caracteres']"
                ref="description"
                v-model="description"
                name="description"
                label="Descripción"
              ></v-textarea>
            </v-col>
          </v-row>
          
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="btn_loading"
            @click="dialog_new=false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="name==''||short_name==''||description==''"
            :loading="btn_loading"
            text
            @click="createPosition()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_edit"
      max-width="700">
      <v-card>
        <v-card-title class="text-h6">
          Editar
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="name"
                outlined
                label="Nombre de la posición">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="short_name"
                outlined
                label="Nombre corto">
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                outlined
                :maxlength="375"
                :counter="375"
                :rules="[v => (v || '' ).length <= 374 || 'La descripción no debe tener mas de 375 caracteres']"
                ref="description"
                v-model="description"
                name="description"
                label="Descripción"
              ></v-textarea>
            </v-col>
          </v-row>
          
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="btn_loading"
            @click="dialog_edit=false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="name==''"
            :loading="btn_loading"
            text
            @click="updatePosition()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_delete"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar esta posición?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="btn_loading"
            @click="dialog_delete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="btn_loading"
            @click="deletePosition"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'CommunicationChannel',

    data: () => ({
      loading:true,
      btn_loading:false,

      dialog_new:false,
      dialog_edit:false,
      dialog_delete:false,
      delete_id:null,
      
      id:null,
      name:'',
      short_name:'',
      description:'',

      positions:[],

      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          filterable: false,
          value: 'id',
          width: '5%'
        },
        {
          text: 'Nombre',
          align: 'start',
          filterable: true,
          value: 'name',
          width: '20%'
        },
        {
          text: 'Posición',
          align: 'start',
          filterable: true,
          value: 'short_name',
          width: '15%'
        },
        {
          text: 'Descipción',
          align: 'start',
          filterable: true,
          value: 'description',
          width: '40%'
        },
        {
          text: 'Acciones',
          align: 'start',
          filterable: false,
          value: 'actions',
          width: '20%'
        },
      ]
    }),

    methods:{
      async getPositions(){
        await axios.get('admin/positions').then(response =>{
          this.positions = response.data.data.positions
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      addComunicactionChannel(){
        this.name=''
        this.short_name=''
        this.description=''
        this.dialog_new=true
        this.btn_loading = false
      },

      async createPosition()
      {
        try {
          this.btn_loading = true
          await axios.post('admin/positions',{ 
            name: this.name,
            short_name: this.short_name,
            description: this.description
          }).then(response =>{
            console.log(response.data)
            this.dialog_new = false
            this.btn_loading = false
            this.loading = true
            this.getPositions()
          })
        } catch (error) {
          this.dialog_new=true
          console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      },

      async editPosition(id){
        this.id=id
        this.btn_loading= true
        try {
          await axios.get('admin/positions/'+id).then(response =>{
            this.name = response.data.data.position.name
            this.short_name = response.data.data.position.short_name
            this.description = response.data.data.position.description
            this.btn_loading=false
            this.dialog_edit=true
          })
        } catch (error) {
          console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      },

      async updatePosition(){
        try {
          this.btn_loading = true
          await axios.put('admin/positions/'+this.id, {
            name: this.name,
            short_name: this.short_name,
            description: this.description
          }).then(() =>{
            this.dialog_edit=false
            this.btn_loading = false
            this.getPositions()
          })
        } catch (error) {
          console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      },

      confirmDelete(id){
        this.dialog_delete = true
        this.delete_id = id
      },

      async deletePosition()
      {
        try {
          this.btn_loading = true
          await axios.delete('admin/positions/'+this.delete_id).then(() =>{
            this.dialog_delete = false
            this.delete_id = null
            this.loading = true
            this.btn_loading = false
            this.getPositions()
          })
        } catch (error) {
          console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
      }

    },

    created(){
      this.getPositions()
    },
  }
</script>